import './App.scss';

function App() {
  return (
    <>
      <div class="noise"></div>
      <div class="overlay"></div>
      <div class="terminal">
        <h1><span class="errorcode">500</span> service unavailable</h1>
        <p class="output">Nextanon has taken <span class="errorcode">42069</span> damage and has been felled.</p>
        <p class="output">I'm no longer part of the TIAWO community and have no interest in promoting their meetings. That's all the detail I'm going into.</p>
        <p class="output">Do whatever you need to do to stay off Kratom. Your recovery is your own. Guard it with your life.</p>
        <p class="output">Deuces. ✌</p>   
      </div>
    </>
  );
}

export default App;
